import { AxiosError } from "axios";
import React, { useEffect, useState } from "react";
/* Project references */
import { CrossCountryEntry, PostCrossCountryEntry } from "../../../models/Admin/CrossCountryEntry";
import { CountryAutoComplete }					    from "../../../models/Autocomplete";
import msalRestClient								from "../../../services/clients/MsalRestClient";

type PostCrossCountryProps = {
	onSuccess: (newEntry : CrossCountryEntry) => void
}

const PostCrossCountry = ({ onSuccess }: PostCrossCountryProps) => {

	/* New empty model for sending to controller */
	let emptyModel: PostCrossCountryEntry = {
		sourceCountryId: -1,
		targetCountryId: -1,
		refundRate: 0
	}

	const [countryAutocomplete, setCountryAutocomplete] = useState<CountryAutoComplete[]>([]);
	const [crossCountry, setCrossCountry] = useState<PostCrossCountryEntry>(emptyModel);

	const [show, setShow]   = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);

	const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

	useEffect(() => {

		setIsSubmitting(true);

		msalRestClient.get<CountryAutoComplete[]>("/api/countries/autocomplete")
			.then(response => {
				setCountryAutocomplete(response.data);
			})
			.catch(error => {
				console.error(error);
			})
			.finally(() => setIsSubmitting(false))

	}, []);

	/**
	 * 
	 */
	async function handleSubmit()
	{
		msalRestClient.post<CrossCountryEntry>("/api/crosscountries", crossCountry)
			.then(response => {
				if (response.status === 200)
				{
					setShow(false);
					onSuccess(response.data);
				}
			})
			.catch((err: AxiosError) => {

				/* Handle an thrown UnprocessableEntityException */
				if (err.response?.status === 422 && err.response?.data && err.response?.data as string)
				{
					setError(err.response.data as string);
				}
			});
	}

	return (
		<>
			<button className="btn btn-success" onClick={e => setShow(true)}>
				<i className="bi bi-plus-circle" /> Add new dataset
			</button>

			<div className={"modal modal-fullscreen-md-down fade" + (show ? " show" : "")} role="dialog" tabIndex={-1}>
				<div className="modal-dialog">
					<div className="modal-content">

						<div className="modal-header">
							<h5>Create a new entry</h5>
							<button type="button" className="btn-close" onClick={e => setShow(false)}></button>
						</div>

						<div className="modal-body">

							{(error !== null) && (
								<div className="row">
									<div className="alert alert-danger fw-bold">
										{error}
									</div>
								</div>
							)}

							<form>
								<div className="row">

									<div className="form-group col-12 col-md-6">
										<label htmlFor="sourceCountry" className="fw-bold">Source Country</label>
										<select id="sourceCountry" name="sourceCountry" className="form-select" defaultValue={crossCountry.sourceCountryId} onChange={e => setCrossCountry(x => ({ ...x, sourceCountryId: Number(e.target.value) }))}>
											<option value={-1}>Please select ...</option>
											{
												countryAutocomplete.map(entry => {
													return (
														<option key={"sc_" + entry.value} value={entry.value}>{entry.displayValue}</option>
													)
												})
											}
										</select>
									</div>

									<div className="form-group col-12 col-md-6">
										<label htmlFor="targetCountry" className="fw-bold">Target Country</label>
										<select id="targetCountry" name="targetCountry" className="form-select" defaultValue={crossCountry.targetCountryId} onChange={e => setCrossCountry(x => ({ ...x, targetCountryId: Number(e.target.value) }))}>
											<option value={-1}>Please select ...</option>
											{
												countryAutocomplete.map(entry => {
													return (
														<option key={"trg_" + entry.value} value={entry.value}>{entry.displayValue}</option>
													)
												})
											}
										</select>
									</div>

									<div className="form-group col-12">
										<label htmlFor="refundRate" className="fw-bold">Refund Rate</label>
										<input type="number" id="refundRate" name="refundRate" className="form-control" onChange={e => setCrossCountry(x => ({ ...x, refundRate: Number(e.target.value) }))} />
									</div>

								</div>
							</form>

						</div>

						<div className="modal-footer">
							<button className="btn btn-danger" type="button" onClick={e => setShow(false)}>Abort</button>

							{isSubmitting  
								? <button className="btn btn-outline-success"><img src="/loading.gif" alt="spinning_loader"></img></button>	
								: <button className="btn btn-success" type="button" onClick={handleSubmit}>Save new Dataset</button>
							}
							

						</div>

					</div>
				</div>
			</div>

		</>
	)
}
export default PostCrossCountry;